import { v4 as uuidv4 } from "uuid";

import { getWindow } from "./getWindow";

// In-memory storage for the current tab's browser ID
let currentBrowserId: string | undefined;

/**
 * Gets or creates a unique browser ID for the current tab session.
 * This ID is unique to the current tab and will be the same for the duration of the tab's session.
 * @returns A string representing the unique browser ID for this tab
 */
export const getBrowserTabId = (): string => {
  if (currentBrowserId) {
    return currentBrowserId;
  }

  const window = getWindow();

  if (!window) {
    // Return a temporary ID for SSR contexts
    return `ssr-browser-id`;
  }

  // If we haven't generated an ID yet for this tab, create one now
  if (!currentBrowserId) {
    currentBrowserId = uuidv4();
  }

  return currentBrowserId;
};
